export const secondaryBuy = {
  ADD_BANK: 'add_bank',
  VERIFY_BANK: 'verify_bank',
  NO_MONEY: 'no_money',
  PENDING_TRANSFER: 'pending_transfer',
};
